import { api } from 'api/apiHelper';

/**
 * sendQrReport
 * @param {*} data
 * @returns ID
 */
export const sendQrReport = (data) => api.post('/crm.deal.add', { fields: data }).then((res) => res.data.result);

export const getBitrixDeals = (filter) => api
  .post('/crm.deal.list', {
    select: ['UF_*', 'STAGE_ID', 'OPENED', 'TITLE'],
    filter,
  })
  .then((res) => res.data);

export const getBitrixContact = (filter) => api
  .post('/crm.contact.list', {
    select: ['*'],
    filter,
  })
  .then((res) => res.data);

export const addBitrixContact = (fields) => api
  .post('/crm.contact.add', {
    fields,
  })
  .then((res) => res.data.result);

export const addBitrixDealContact = (id, fields) => api
  .post('/crm.deal.contact.add', {
    id,
    fields,
  })
  .then((res) => res.data);
